export const SET_ALUNO_TURMA = 'SET_ALUNO_TURMA'
export const SET_ALUNOS_TURMA = 'SET_ALUNOS_TURMA'
export const ADD_ALUNOS_TURMA = 'ADD_ALUNOS_TURMA'
export const UPDATE_ALUNOS_TURMA = 'UPDATE_ALUNOS_TURMA'
export const REMOVE_ALUNOS_TURMA = 'REMOVE_ALUNOS_TURMA'
export const OPEN = 'OPEN';
export const CLOSE = 'CLOSE';